'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const faqs = [
  {
    id: 'faq-1',
    question: 'Como funcionam os créditos gratuitos?',
    answer: 'Cada utilizador recebe 75 créditos gratuitos por dia, renovados automaticamente. Estes créditos são utilizados primeiro em cada geração. Os créditos diários não se acumulam — no novo dia, o saldo é reposto para 75.',
  },
  {
    id: 'faq-2',
    question: 'O que acontece quando os créditos gratuitos acabam?',
    answer: 'Quando os créditos diários gratuitos terminam, o sistema utiliza automaticamente os créditos comprados, se existirem. Caso contrário, é apresentada uma mensagem com a opção de comprar créditos ou aguardar até ao dia seguinte.',
  },
  {
    id: 'faq-3',
    question: 'Os créditos comprados expiram?',
    answer: 'Não. Os créditos comprados são permanentes e nunca expiram. São mantidos separados dos créditos diários gratuitos e utilizados apenas após os créditos diários serem esgotados.',
  },
  {
    id: 'faq-4',
    question: 'Qual é a diferença entre os modelos de IA?',
    answer: 'O modelo Free é ideal para jogos simples e experimentação (5 créditos/geração). O modelo Pro oferece maior qualidade e complexidade (15 créditos/geração). O modelo Advanced é o mais poderoso para jogos complexos e detalhados (30 créditos/geração).',
  },
  {
    id: 'faq-5',
    question: 'Posso editar o jogo depois de gerado?',
    answer: 'Sim! Após a geração, tens acesso a um editor completo com pré-visualização do jogo e um chat com IA. Podes pedir modificações em linguagem natural: "adiciona inimigos", "muda o fundo", "torna o jogo mais difícil".',
  },
  {
    id: 'faq-6',
    question: 'Como funciona a publicação de jogos?',
    answer: 'Após estares satisfeito com o teu jogo, clicas em "Publicar" e defines o nome, descrição, thumbnail e categoria. O jogo fica disponível na plataforma com uma URL pública para partilhar com toda a gente.',
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>('faq-1');

  return (
    <section className="py-20 px-4 lg:px-8 xl:px-12 2xl:px-16 max-w-screen-2xl mx-auto">
      <div className="text-center mb-14">
        <h2 className="text-hero-lg text-foreground mb-4">Perguntas frequentes</h2>
        <p className="text-muted-foreground">Tudo o que precisas de saber sobre o Core Forges.</p>
      </div>

      <div className="max-w-3xl mx-auto space-y-3">
        {faqs?.map((faq) => (
          <div
            key={faq?.id}
            className={`rounded-xl border transition-all duration-200 overflow-hidden ${openId === faq?.id ? 'border-primary/30 bg-primary/5' : 'border-border bg-card'}`}
          >
            <button
              onClick={() => setOpenId(openId === faq?.id ? null : faq?.id)}
              className="w-full flex items-center justify-between px-5 py-4 text-left"
            >
              <span className="font-medium text-foreground text-sm">{faq?.question}</span>
              <Icon
                name={openId === faq?.id ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                size={16}
                className="text-muted-foreground flex-shrink-0 ml-4"
              />
            </button>
            {openId === faq?.id && (
              <div className="px-5 pb-4 animate-fade-in">
                <p className="text-sm text-muted-foreground leading-relaxed">{faq?.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}